import 'bootstrap/dist/css/bootstrap.css';
import { Component } from 'react';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import {Link} from 'react-router-dom';
import discovery from './discoveryphoto.jpeg'
import './components/styles.css'
class LandingPage extends Component{


render(){
  return(
    <div style={{ position: "relative" }}>
    <Navbar />
    <div className="bonustext" style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", marginTop:"10vh" }}>
        <h1 style={{ textAlign: "center", backgroundColor: "#D9E724", display: "inline-block", padding: "5px", borderRadius:"7px", color:"#212121", borderStyle: "solid", borderColor: "#212121"  }}><b>Welcome to FeatFinder!</b></h1>
</div>
<div className="bonustext" style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -50%)", marginTop:"15.6vh" }}>
<p style={{ textAlign: "center", backgroundColor: "#D9E724", display: "inline-block", padding: "4px", borderBottomLeftRadius:"7px", borderBottomRightRadius:"7px", color:"#212121" , borderStyle: "solid", borderColor: "#212121", borderTopColor: "#D9E724"}}><i>Choose one of the two available modes to start!</i></p>
</div>

    <Link to="/classic">
    <div className='classic'>
    <h1 style={{marginTop: "65vh", color: "white"}}>Classic Mode</h1>
    <p style={{color: "white"}}>Select two artists to find out if they ever made a song together</p>
    </div>
    </Link>
    <Link to="/discovery" style={{textDecoration: 'none'}}>
    <div className='discovery'>
    <h1 style={{marginTop: "65vh", color: "white"}}>Discovery Mode</h1>
    <p style={{color: "white"}}>Select an artist to <i>discover</i> a list of collaborations</p>
    </div>
    </Link>
    
  </div>
  


)

}}

export default LandingPage;